import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

//Changed
import {
  getNoticeDetail,
  updateNotice,
  deleteNotice,
} from "../../../api/meeting";

import TinyMCEeditor from "../../../components/const/TinyMCEeditor";
import TinyMCEpreview from "../../../components/const/TinyMCEpreview";
import { softDeleteDoc } from "../../../api/papers";
import TableCell from "../../../components/common/ui/TableCell";
import PageHeader from "../../../components/common/ui/PageHeader";


//Changed
export default function NoticeView() {
  //Changed
  const { id, noticeId } = useParams();
  const navigate = useNavigate();
  const editorRef = useRef(null);

  const [item, setItem] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [title, setTitle] = useState("");

  const fetchData = async () => {
    try {
      //Changed
      const res = await getNoticeDetail(noticeId);
      setItem(res.data);
      setTitle(res.data.title);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [noticeId]); //Changed

  const handleSave = async () => {
    const newContext = editorRef.current?.getContent() ?? "";

    try {
      //Changed
      await updateNotice(noticeId, {
        meta: {
          title,
          context: newContext,
        },
      });

      alert("수정되었습니다.");
      setIsEdit(false);
      fetchData();
    } catch (e) {
      console.error(e);
      alert("수정 실패");
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("삭제하시겠습니까?")) return;

    try {
      await softDeleteDoc(noticeId, true);
      alert("삭제되었습니다.");
      //Changed
      navigate(`/project/${id}/meeting/notice`);
    } catch (e) {
      console.error(e);
    }
  };

  function formatKoreanDate(datetime) {
    if (!datetime) return "";
    const d = new Date(datetime);

    return `${d.getFullYear()}년 ${d.getMonth() + 1
      }월 ${d.getDate()}일 ${String(d.getHours()).padStart(2, "0")}:${String(
        d.getMinutes()
      ).padStart(2, "0")}`;
  }

  if (!item) return <p className="p-6">불러오는 중...</p>;

  return (
    <div className="p-6 space-y-4">
      <PageHeader showBack>공지사항</PageHeader>

      {/* 공지 헤더 + 버튼 */}
      <div className="flex justify-end">

        <div className="flex gap-2">
          {isEdit ? (
            <>
              <button className="btn-create px-5" onClick={handleSave}>저장</button>
              <button className="btn-cancel px-5" onClick={() => setIsEdit(false)}>취소</button>
            </>
          ) : (
            <button className="btn-edit px-5" onClick={() => setIsEdit(true)}>수정</button>
          )}

          <button className="btn-delete px-5" onClick={handleDelete}>삭제</button>
        </div>
      </div>

      {/* ============================
      테이블셀 기반 정보 영역
  ============================ */}
      <div className="page-box">
        <div className="overflow-hidden">
          <table className="w-full text-sm">
            <tbody>

              {/* 제목 */}
              <tr>
                <TableCell
                  label="제목"
                  colSpan={1}
                  editing={isEdit}
                  input={
                    <input
                      type="text"
                      className="input-base w-full"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  }
                  value={item.title}
                />
              </tr>

              {/* 작성자 */}
              <tr>
                <TableCell label="작성자" value={item.created_by ?? "-"} />
              </tr>

              {/* 작성일 */}
              <tr>
                <TableCell
                  label="작성일"
                  value={formatKoreanDate(item.created_at)}
                />
              </tr>

              {/* 내용 (여기 새로 변경됨!!) */}
              <tr>
                <TableCell
                  label="내용"
                  colSpan={1}
                  rich={true}
                  editing={isEdit}
                  input={
                    <TinyMCEeditor
                      initialValue={item.meta.context}
                      editorRef={editorRef}
                    />
                  }
                  value={<TinyMCEpreview html={item.meta.context} />}
                />
              </tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>

  );
}
